import { FontTypeEnum } from 'src/app/model/enums/FontTypeEnum';
import { ElementRef } from '@angular/core';
import { OnInit } from '@angular/core';
import { Directive } from '@angular/core';
import { SessionService } from '../session-service.service';

@Directive({
  selector: '[appConfigSettingsTitle]'
})
export class ConfigSettingsTitleDirective implements OnInit {

  FontTypeEnum = FontTypeEnum;
  constructor(private elementRef: ElementRef, private sessionService: SessionService) { }

  ngOnInit(): void {
    this.elementRef.nativeElement.style.color = this.sessionService.getConfigSettingsDto().fontColor;
    this.elementRef.nativeElement.style.fontFamily =  FontTypeEnum[this.sessionService.getConfigSettingsDto().fontType] || FontTypeEnum.Sun;
    this.elementRef.nativeElement.style.fontSize = this.sessionService.getConfigSettingsDto().fontSizeH1 + 'px';
    this.elementRef.nativeElement.style.backgroundColor = this.sessionService.getConfigSettingsDto().backgroundColor;
  }
}
